import { Component } from '@angular/core';
import { LanguageSelectorComponent } from '../../components/language-selector/language-selector.component';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-case-closed-dialog',
  templateUrl: './case-closed-dialog.component.html',
  styleUrls: ['./case-closed-dialog.component.scss'],
  imports: [LanguageSelectorComponent, MatButton, TranslateModule],
})
export class CaseClosedDialogComponent {}
